import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';
import { ILegacyUpgrade } from 'src/app/core/interfaces/onboarding/legacy-upgrade/legacy-upgrade.interface';

export abstract class AbstractLegacyUpgradeService {
  abstract saveLegacyUpgrade(model: ILegacyUpgrade): Promise<IApiResponse>;
}
